import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "episode-card__img-box" }

import { IS_PRERENDERING } from '@/init/settings'
import { EpisodeListItem } from '@/models/interfaces'
import { computed } from 'vue'
import LazyImage from './LazyImage.vue'
import PublicImage from './PublicImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EpisodeCardCover',
  props: {
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  doc: EpisodeListItem
};



/* Lazy load is disabled for static pages.

  Note: When accessing the static page locally, we will not see any cover_images
  unless we've build them using the build.sh script.

*/

const lazyComponent = computed(() => {
  return !IS_PRERENDERING ? LazyImage : PublicImage
})
const coverUrl = 'https:' + props.doc.cover_image

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(lazyComponent)), {
      src: coverUrl,
      crossorigin: "anonymous",
      class: "episode-card__img",
      alt: ""
    }))
  ]))
}
}

})